/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_Feature_1_DescInputs */

const es_home_nexy_feature_1_desc = /** @type {(inputs: Home_Nexy_Feature_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontrá documentos por concepto, no solo por palabra clave exacta.`)
};

const en_home_nexy_feature_1_desc = /** @type {(inputs: Home_Nexy_Feature_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find documents by concept, not just exact keywords.`)
};

/**
* | output |
* | --- |
* | "Find documents by concept, not just exact keywords." |
*
* @param {Home_Nexy_Feature_1_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_feature_1_desc = /** @type {((inputs?: Home_Nexy_Feature_1_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_Feature_1_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_feature_1_desc(inputs)
	return en_home_nexy_feature_1_desc(inputs)
});
export { home_nexy_feature_1_desc as "home.nexy.feature_1_desc" }